import React from "react";
import { Field, Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../General-UI/InputField";
import {
  MAX_NAME_LENGTH,
  PASSWORD_REGEX,
  PASSWORD_REQUIREMENT,
} from "constants/constants";
import {
  selectRegisterError,
  selectTryingRegister,
  selectUserPending,
  tryRegister,
} from "slices/authSlice";
import { selectCreateNewAccountModal } from "slices/signInPageSlice";

const validate = (formValues) => {
  const errors = {};
  if (!formValues.firstName) {
    errors.firstName = "Enter Your Given Name";
  } else if (formValues.firstName.length > MAX_NAME_LENGTH) {
    errors.firstName =
      "First Name too long (>" + MAX_NAME_LENGTH.toString() + " letters)";
  }
  if (!formValues.lastName) {
    errors.lastName = "Enter Your Family Name";
  } else if (formValues.lastName.length > MAX_NAME_LENGTH) {
    errors.lastName =
      "Last name too long (>" + MAX_NAME_LENGTH.toString() + " letters)";
  }
  if (!formValues.email) {
    errors.email = "You must enter an email";
  } else if (formValues.email.length > MAX_NAME_LENGTH) {
    errors.email =
      "Email too long (>" + MAX_NAME_LENGTH.toString() + " letters)";
  }
  if (!formValues.password) {
    errors.password = "You must enter a password";
  } else if (!formValues.password.match(PASSWORD_REGEX)) {
    errors.password = PASSWORD_REQUIREMENT;
  }

  return errors;
};

const RegisterDetails = ({ hidden }) => {
  const dispatch = useDispatch();
  const tryingRegister = useSelector(selectTryingRegister);
  const registerError = useSelector(selectRegisterError);
  const userPending = useSelector(selectUserPending);
  const createNewAccountModal = useSelector(selectCreateNewAccountModal);

  return (
    <div className="inline-form">
      <Form
        onSubmit={(formValues) => {
          dispatch(tryRegister(formValues));
        }}
        validate={validate}
      >
        {({ handleSubmit, form }) => {
          if (!createNewAccountModal || userPending) {
            form.restart();
          }
          return (
            <form
              onSubmit={handleSubmit}
              style={hidden ? { display: "none" } : null}
            >
              <Field
                name="firstName"
                type="text"
                component={InputField}
                placeholder="First Name"
                className="input-box"
                align="signUpNames"
                liveCheck={true}
              />

              <span className="signUpNames-spacer"></span>

              <Field
                name="lastName"
                type="text"
                component={InputField}
                placeholder="Last Name"
                className="input-box"
                align="signUpNames"
                liveCheck={true}
              />

              <div>
                <Field
                  name="email"
                  component={InputField}
                  type="email"
                  placeholder="Email address"
                  className="input-box"
                  liveCheck={true}
                />
              </div>
              <div>
                <Field
                  name="password"
                  component={InputField}
                  type="password"
                  placeholder="Password"
                  className="input-box"
                  liveCheck={true}
                />
              </div>
              <button
                onClick={handleSubmit}
                type="submit"
                className="confirm-button growth-button mt-1"
                disabled={tryingRegister}
              >
                {tryingRegister ? "Signing Up..." : "Sign Up"}
              </button>
              <div className="server-response-error">
                {registerError ? registerError.message : null}
              </div>
              <div className="stuff-no-one-reads">
                By signing up, I accept the EfficeSpace{" "}
                <a
                  href="https://efficespace.com/efficespace-terms-and-conditions-of-use/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions of Use
                </a>{" "}
                and acknowledge the{" "}
                <a
                  href="https://efficespace.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>{" "}
              </div>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

export default RegisterDetails;
